export default "__VITE_ASSET__D4kg0NFd__"